import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '../../lib/utils'

const badgeVariants = cva(
  'inline-flex items-center justify-center px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default:
          'rounded-full border border-transparent bg-primary text-primary-foreground hover:bg-primary/80',
        secondary:
          'rounded-full border border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        destructive:
          'rounded-full border border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80',
        outline: 'rounded-full text-foreground border hover:bg-secondary/80',
        plain: 'border-none bg-transparent p-0', // New variant with no background or border
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />
}

export { Badge, badgeVariants }
